import {TItemId, isProdDomain} from 'src/constants';

const YM_ID = 95865849;
const YM_MARKETING_ID = 45959760;

enum EMetricsType {
  CLICK = 'CLICK',
}

enum ECounterType {
  MARKETING = 'MARKETING',
  PULSE = 'PULSE',
}

type TCounterType = keyof typeof ECounterType;

const counterHashYM = {
  [ECounterType.PULSE]: YM_ID,
  [ECounterType.MARKETING]: YM_MARKETING_ID,
};

enum EMetricsId {
  // Subscribers
  SUBSCRIBERS_ADD_LIST = 'AUDIENCE_ADD-CLIENTS-LIST',
  SUBSCRIBERS_ADD = 'AUDIENCE_ADD-CLIENT',
  // MessageMatchers
  TEMPLATE_ADD = 'TEMPLATES_ADD-TEMPLATE',
  TEMPLATE_SAVE = 'TEMPLATES_SAVE-TEMPLATE',
  TEMPLATE_SAVE_DRAFT = 'TEMPLATES_SAVE-DRAFT-TEMPLATE',
  TEMPLATE_CHECK_TEXT_WITH_AI = 'template-createWA-step2-buttonCheckWithAI',
  TEMPLATE_SELECT_MARKETING_BUTTON_CONTINUE = 'template-createWA-step1-selectMarketing-buttonContinue',
  // Cascades
  CASCADE_ADD = 'CASCADES_ADD-CASCADE',
  CASCADE_SAVE = 'CASCADES_SAVE-CASCADE',
  // Broadcast
  BROADCAST_ADD_BROADCAST = 'broadcast-create-button',
  // Broadcast Step 1
  BROADCAST_STEP1_CHANGE_TIMEZONE = 'broadcast-create-step1-change-timezone',
  BROADCAST_STEP1_USE_LOCAL_TIME = 'broadcast-create-step1-use-clients-local-time',
  BROADCAST_STEP1_IGNORE_LOCAL_TIME = 'broadcast-create-step1-ignore-clients-local-time',
  BROADCAST_STEP1_CHANGE_RPS = 'broadcast-create-step1-change-messages-per-second',
  BROADCAST_STEP1_ADD_TRIGGERS = 'broadcast-create-step1-integration-with-trigger-chains',
  BROADCAST_STEP1_ADD_COMMENT = 'broadcast-create-step1-additional-info-filled',
  BROADCAST_STEP1_CANCEL = 'broadcast-create-step1-buttonCancel',
  BROADCAST_STEP1_SAVE = 'broadcast-create-step1-buttonSave',
  BROADCAST_STEP1_CONTINUE = 'broadcast-create-step1-buttonContinue',
  BROADCAST_STEP1_BACK = 'broadcast-create-step1-back',
  // Broadcast Step 2
  BROADCAST_STEP2_SUBSCRIBERS_ADD = 'broadcast-create-step2-buttonAddRecipients',
  BROADCAST_STEP2_MODAL_SUBSCRIBERS_ATTACH = 'broadcast-create-step2-modalUpload-doc-attach-file',
  BROADCAST_STEP2_MODAL_SUBSCRIBERS_UPLOAD = 'broadcast-create-step2-modalUpload-doc-upload',
  BROADCAST_STEP2_TAGS_ASSIGN = 'BROADCASTS_ASSIGN-TAG',
  BROADCAST_STEP2_MODAL_TAGS_PRESS = 'broadcast-create-step2-modalSelectAttributes-selectAddTag-pressed',
  BROADCAST_STEP2_MODAL_TAGS_SELECT = 'broadcast-create-step2-modalSelectAttributes-selectAddTag-tags-chosen',
  BROADCAST_STEP2_MODAL_TAGS_CREATE = 'broadcast-create-step2-modalSelectAttributes-selectAddTag-buttonAddTag',
  BROADCAST_STEP2_MODAL_TAGS_CREATED = 'broadcast-create-step2-from-modalSelectAttributes-modalAddTag-buttonAdd',
  BROADCAST_STEP2_MODAL_TAGS_CANCEL_CREATING = 'broadcast-create-step2-from-modalSelectAttributes-modalAddTag-buttonCancel',
  BROADCAST_STEP2_MODAL_TAGS_TREE_PRESS = 'broadcast-create-step2-modalSelectAttributes-buttonTagTree',
  BROADCAST_STEP2_MODAL_TAGS_TREE_SELECT = 'broadcast-create-step2-from-modalSelectAttributes-modalSelectTagsFromTheTree-tags-chosen-from-categories',
  BROADCAST_STEP2_MODAL_TAGS_TREE_SEARCH = 'broadcast-create-step2-from-modalSelectAttributes-modalSelectTagsFromTheTree-search',
  BROADCAST_STEP2_MODAL_TAGS_TREE_SELECT_FROM_SEARCH = 'broadcast-create-step2-from-modalSelectAttributes-modalSelectTagsFromTheTree-tags-chosen-from-searchResult',
  BROADCAST_STEP2_MODAL_TAGS_TREE_CREATE = 'broadcast-create-step2-from-modalSelectAttributes-modalSelectTagsFromTheTree-buttonNewTag',
  BROADCAST_STEP2_MODAL_TAGS_TREE_CREATED = 'broadcast-create-step2-from-modalSelectAttributes-from-modalSelectTagsFromTheTree-modalAddTag-buttonAddTag',
  BROADCAST_STEP2_MODAL_TAGS_TREE_CANCEL_CREATING = 'broadcast-create-step2-from-modalSelectAttributes-from-modalSelectTagsFromTheTree-modalAddTag-buttonCancel',
  BROADCAST_STEP2_MODAL_TRIGGERS_SELECT = 'broadcast-create-step2-modalSelectAttributes-selectOneOrMoreScenarios',
  BROADCAST_STEP2_MODAL_VARIABLE_CREATE = 'broadcast-create-step2-modalSelectAttributes-buttonAddVariable',
  BROADCAST_STEP2_MODAL_VARIABLE_CREATED = 'broadcast-create-step2-from-modalSelectAttributes-modalAddVariable-buttonAdd',
  BROADCAST_STEP2_MODAL_ATTRIBUTES_SELECTED = 'broadcast-create-step2-modalSelectAttributes-buttonContinue',
  BROADCAST_STEP2_MODAL_ATTRIBUTES_CANCELED = 'broadcast-create-step2-modalSelectAttributes-buttonCancel',
  BROADCAST_STEP2_MODAL_SUBSCRIBERS_EXCLUDE_SELECT = 'broadcast-create-step2-modalWhatToDoWithAudience-exclude',
  BROADCAST_STEP2_MODAL_SUBSCRIBERS_EXCLUDE_BACK = 'broadcast-create-step2-modalWhatToDoWithAudience-buttonBack',
  BROADCAST_STEP2_TAGS_SEARCH = 'broadcast-create-step2-search-tag',
  BROADCAST_STEP2_TAGS_SELECT_FROM_SEARCH = 'broadcast-create-step2-tags-chosen-from-searchResult',
  BROADCAST_STEP2_TAGS_CATEGORY_SELECT = 'broadcast-create-step2-click-category',
  BROADCAST_STEP2_TAGS_FROM_CATEGORY_SELECT = 'broadcast-create-step2-click-tag-from-category',
  BROADCAST_STEP2_TAGS_BANNER_CLICK = 'broadcast-create-step2-click-warningBanner',
  BROADCAST_STEP2_TAGS_INCLUDE_BLOCK_PRESS = 'broadcast-create-step2-click-include-recipients',
  BROADCAST_STEP2_TAGS_INCLUDE_ADD_GROUP = 'broadcast-create-step2-buttonAddAnotherGroup-include-recipients',
  BROADCAST_STEP2_TAGS_EXCLUDE_BLOCK_PRESS = 'broadcast-create-step2-click-exclude-recipients',
  BROADCAST_STEP2_TAGS_EXCLUDE_ADD_GROUP = 'broadcast-create-step2-buttonAddAnotherGroup-exclude-recipients',
  BROADCAST_STEP2_TAGS_INCLUDE_ADD_OPERATOR_AND = 'broadcast-create-step2-buttonAnd-include-recipients',
  BROADCAST_STEP2_TAGS_EXCLUDE_ADD_OPERATOR_AND = 'broadcast-create-step2-buttonAnd-exclude-recipients',
  BROADCAST_STEP2_CANCEL = 'broadcast-create-step2-cancel',
  BROADCAST_STEP2_SAVE = 'broadcast-create-step2-save',
  BROADCAST_STEP2_CONTINUE = 'broadcast-create-step2-continue',
  // Broadcast Step 3
  BROADCAST_STEP3_SUBJECT_SELECT_WA = 'broadcast-create-step3-1channel-selectChooseChannel-WA-filled',
  BROADCAST_STEP3_WA_MAU_BANNER_CLICK = 'broadcast-create-step3-1channel-WA-clickMauWarningBanner',
  BROADCAST_STEP3_WA_OPERATOR_TEMPLATE_SELECT = 'broadcast-create-step3-1channel-WA-selectOperatorTemplate',
  BROADCAST_STEP3_WA_USER_TEMPLATE_SELECT = 'broadcast-create-step3-1channel-WA-selectCustomerTemplate',
  BROADCAST_STEP3_WA_SEND_TEST = 'broadcast-create-step3-1channel-WA-SendTest',
  BROADCAST_STEP3_WA_TEST_SENT = 'broadcast-create-step3-1channel-WA-modalSendMessage-buttonSend',
  BROADCAST_STEP3_SUBJECT_SELECT_SMS = 'broadcast-create-step3-1channel-selectChooseChannel-SMS-filled',
  BROADCAST_STEP3_SMS_NO_TEMPLATE_VARIABLE_INSERT = 'broadcast-create-step3-1channel-SMS-noTemplate-buttonInsertVariable',
  BROADCAST_STEP3_SMS_NO_TEMPLATE_VARIABLE_SELECT = 'broadcast-create-step3-1channel-SMS-noTemplate-selectVariable-chosen',
  BROADCAST_STEP3_SMS_NO_TEMPLATE_VARIABLE_CREATE = 'broadcast-create-step3-1channel-SMS-noTemplate-buttonAddVariable',
  BROADCAST_STEP3_SMS_NO_TEMPLATE_VARIABLE_CREATED = 'broadcast-create-step3-1channel-SMS-noTemplate-modalAddVariable-buttonAdd',
  BROADCAST_STEP3_SMS_NO_TEMPLATE_CONTENT_CHECK = 'broadcast-create-step3-1channel-SMS-noTemplate-buttonCheckForTemplateCompliance',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_SELECT = 'broadcast-create-step3-1channel-SMS-selectOperatorTemplate',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_SELECT = 'broadcast-create-step3-1channel-SMS-OperatorTemplate-selectVariable-chosen',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_CREATE = 'broadcast-create-step3-1channel-SMS-OperatorTemplate-selectVariable-buttonAddVariable',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_CREATED = 'broadcast-create-step3-1channel-SMS-operatorTemplate-modalAddVariable-buttonAdd',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_CONVERT_TO_TEXT = 'broadcast-create-step3-1channel-SMS-operatorTemplate-buttonChangeToText',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_FILL_TEXT = 'broadcast-create-step3-1channel-SMS-OperatorTemplate-regText-chosen',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_TEXT_CONTENT_CHECK = 'broadcast-create-step3-1channel-SMS-OperatorTemplate-regText-buttonCheckForTemplateCompliance',
  BROADCAST_STEP3_SMS_OPERATOR_TEMPLATE_VARIABLE_CONTENT_CHECK = 'broadcast-create-step3-1channel-SMS-OperatorTemplate-regVariable-buttonCheckForTemplateCompliance',
  BROADCAST_STEP3_SMS_SEND_TEST = 'broadcast-create-step3-1channel-SMS-SendTest',
  BROADCAST_STEP3_CONTINUE = 'broadcast-create-step3-continue',
  // Broadcast Step 4
  BROADCAST_STEP4_CHECK_SETTINGS_EDIT = 'broadcast-create-step4-from-mailingSettings-buttonEdit',
  BROADCAST_STEP4_CHECK_SUBSCRIBERS_EDIT = 'broadcast-create-step4-from-mailingAudience-buttonEdit',
  BROADCAST_STEP4_CHECK_CONTENT_EDIT = 'broadcast-create-step4-from-mailingContent-buttonEdit',
  BROADCAST_STEP4_SEND = 'broadcast-create-step4-send',
  BROADCAST_STEP4_CANCEL = 'broadcast-create-step4-cancel',
  BROADCAST_STEP4_SEND_CONFIRM_ACCEPT = 'broadcast-create-step2-modalSendBroadcast-buttonSend',
  BROADCAST_STEP4_SEND_CONFIRM_CANCEL = 'broadcast-create-step2-modalSendBroadcast-buttonBack',
  BROADCAST_STEP4_TIMER_SEND_IMMEDIATELY = 'broadcast-create-step4-modalSendBroadcast-buttonSendImmediately',
  BROADCAST_STEP4_TIMER_CANCEL = 'broadcast-create-step4-modalSendBroadcast-buttonGoback',
  BROADCAST_STEP4_SENT = 'broadcast-create-step4-modalYourBroadcastIsSent-buttonGoToList',
  BROADCAST_STEP4_MAU_CHECK = 'create-broadcast-4step-MAU-check',
  // Onboarding
  OWNER_SURVEY_START = 'owner-onboarding-survey-start',
  OWNER_ONBOARDING_SURVEY_STEP1 = 'owner-onboarding-survey-step1',
  OWNER_ONBOARDING_SURVEY_STEP2 = 'owner-onboarding-survey-step2',
  OWNER_ONBOARDING_SURVEY_STEP3 = 'owner-onboarding-survey-step3',
  OWNER_ONBOARDING_SURVEY_STEP4 = 'owner-onboarding-survey-step4',
  OWNER_ONBOARDING_SURVEY_STEP5 = 'owner-onboarding-survey-step5',
  NEW_USER_ONBOARDING_SURVEY_START = 'new-user-onboarding-survey-start',
  NEW_USER_ONBOARDING_SURVEY_STEP1 = 'new-user-onboarding-survey-step1',
  NEW_USER_ONBOARDING_SURVEY_STEP2 = 'new-user-onboarding-survey-step2',
  NEW_USER_ONBOARDING_SURVEY_STEP3 = 'new-user-onboarding-survey-step3',
  // Others
  SCROLL_TO_TOP = 'list-up-button-click',
  FEEDBACK_FORM_OPENED = 'feedback-form-opened',
  FEEDBACK_FORM_CANCELED = 'feedback-form-canceled',
  WIDGET_BUTTON_PRESSED = 'widget-button-pressed',
  PROFILE_DOWNLOAD_BILLING_STATISTICS = 'PROFILE_DOWNLOAD-BILLING-STATISTICS',
  NEWS_BLOG_PAGE_VISITED = 'news-blog-page-visited',
  NEWS_CASES_PAGE_VISITED = 'news-cases-page-visited',
  SPECIAL_OFFER_REQUEST = 'company-profile-special-offer-request',
  // Self registration flow
  SELF_REGISTRATION_STEP1 = 'samoreg-registration-step1-country',
  SELF_REGISTRATION_STEP2 = 'samoreg-registration-step2-name',
  SELF_REGISTRATION_STEP3 = 'samoreg-registration-step3-phone',
  SELF_REGISTRATION_STEP4 = 'samoreg-registration-step4-email',
  SELF_REGISTRATION_SUCCESS = 'samoreg-registration-success',
  SELF_REGISTRATION_CREATE_PASSWORD = 'samoreg-password-page',
  SELF_REGISTRATION_FIRST_LOGIN = 'samoreg-first-login',
  // Self registration onboarding
  ONBOARDING_MODULE_MAX = 'main-adModule-SimpleMax',
  ONBOARDING_MODULE_DIALOGS = 'main-adModule-Dialogs',
  ONBOARDING_MODULE_TRIGGERS = 'main-adModule-ScenarioBuilder',
  ONBOARDING_MODULE_CASCADES = 'main-adModule-Cascades',
  ONBOARDING_MODULE_INTEGRATION = 'main-adModule-Api',
  ONBOARDING_CONNECT_TARIFF_MAX = 'main-adTarif-ActivateMaxBusinessButton',
  ONBOARDING_CONNECT_TARIFF_MAX_BOT = 'main-adTarif-ActivateMaxBotBusinessButton',
  ONBOARDING_CONNECT_TARIFF_WHATSAPP = 'main-adTarif-ActivateWhatsAppButton',
  ONBOARDING_STEP_DETAILS = 'main-adOnboardingSteps-step1-fillDetialsButton',
  ONBOARDING_STEP_CHANNEL = 'main-adOnboardingSteps-step2-connectChannelButton',
  ONBOARDING_STEP_LICENSE = 'main-adOnboardingSteps-step3-topUpBalanceButton',
  ONBOARDING_STEP_INTEGRATION = 'main-adOnboardingSteps-step4-openIntegrationsButton',
  ONBOARDING_STEP_SELECT_TEMPLATE = 'main-adOnboardingSteps-step5-selectTemplateButton',
  // Self registration menu clicks
  MENU_MAIN_CLICK = 'mainMenu-chapter-main',
  MENU_BROADCASTS_CLICK = 'mainMenu-chapter-broadcast',
  MENU_TEMPLATES_CLICK = 'mainMenu-chapter-template',
  MENU_TRIGGERS_CLICK = 'mainMenu-chapter-scenario',
  MENU_CHANNELS_CLICK = 'mainMenu-chapter-channel',
  MENU_AUDIENCE_CLICK = 'mainMenu-chapter-audience',
  MENU_MESSAGE_REPORT_CLICK = 'mainMenu-chapter-analytics-subchapter-messageReport',
  MENU_SUMMARY_REPORT_CLICK = 'mainMenu-chapter-analytics-subchapter-summaryReport',
  MENU_TEMPLATE_REPORT_CLICK = 'mainMenu-chapter-analytics-subchapter-templateReport',
  MENU_CASCADES_CLICK = 'mainMenu-chapter-cascade',
  MENU_INTEGRATION_CLICK = 'mainMenu-chapter-integration',
  MENU_MY_PROFILE_CLICK = 'mainMenu-chapter-profile-subchapter-myProfile',
  MENU_COMPANY_PROFILE_CLICK = 'mainMenu-chapter-profile-subchapter-companyProfile',
  MENU_NEWS_CLICK = 'mainMenu-chapter-profile-subchapter-news',
  MENU_HELP_CLICK = 'mainMenu-chapter-help',
  MENU_EVENT_LOG_NOTIFICATIONS_CLICK = 'mainMenu-chapter-eventLog-subchapter-notifications',
  MENU_EVENT_LOG_DOWNLOADS_CLICK = 'mainMenu-chapter-eventLog-subchapter-downloads',
  MENU_LOGO_CLICK = 'mainMenu-logo',
  AB_TEST_BROADCAST_BUTTON_CLICK = 'mailing3step-fakeDoor-launchABtest-button',
  AB_TEST_BROADCAST_ACCEPT = 'mailing3step-fakeDoor-findOut-button',
  AB_TEST_BROADCAST_SEND_EMAIL = 'mailing3step-fakeDoor-emailFormSent',
}

type TMetricsId = `${EMetricsId}`;

const YMCategoryMap = {
  [EMetricsType.CLICK]: 'reachGoal',
};

const GACategoryMap = {
  [EMetricsType.CLICK]: 'click',
};

type TSendMetrics =
  | TMetricsId
  | EMetricsId
  | {
      id: TMetricsId;
      counterType?: TCounterType[] | TCounterType;
      category?: keyof typeof EMetricsType;
      params?: TAnyObject;
    };

const sendMetrics = (data: TSendMetrics, tenantId?: TItemId | null) => {
  if (!isProdDomain()) {
    return;
  }

  if (tenantId) {
    window.ym?.(YM_ID, 'userParams', {
      tenant_id: tenantId,
      UserID: tenantId,
    });
  }

  if (typeof data === 'string') {
    window.ym?.(YM_ID, YMCategoryMap.CLICK, data, {tenant_id: tenantId});
    window.gtag?.('event', GACategoryMap.CLICK, {event_category: data});

    return;
  }

  const {id, category = EMetricsType.CLICK, params = {}, counterType = ECounterType.PULSE} = data;

  if (Array.isArray(counterType)) {
    counterType.forEach((counter) => {
      window.ym?.(counterHashYM[counter], YMCategoryMap[category], id, {
        ...params,
        tenantId,
        tenant_id: tenantId,
      });
    });
  } else {
    window.ym?.(counterHashYM[counterType], YMCategoryMap[category], id, {
      ...params,
      tenantId,
      tenant_id: tenantId,
    });
  }

  window.gtag?.('event', GACategoryMap[category], params);
};

const sendPageMetrics = (pathname: string) => {
  if (!isProdDomain()) {
    return;
  }

  window.gtag?.('event', 'page_view', {
    page_path: pathname,
  });
};

export {sendMetrics, sendPageMetrics, EMetricsId, TSendMetrics};
